module.exports = __webpack_public_path__ + "static/media/link-pink.5d522fbe.svg";